import React from 'react';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { SelectionList } from '@ygtechnologies/rubus-ui';
import { ProjectProfile } from '@/types';
import theme from './OrderResponsibleSelection.module.scss';
import { ProfileIcon } from '@/components/Icons';

interface OrderResponsibleSelectionProps {
    members: ProjectProfile[];
    value: ProjectProfile | null;
    onChange(newValue: ProjectProfile | null): void;
}

const OrderResponsibleSelection: React.FC<OrderResponsibleSelectionProps> = ({ members, value, onChange }) => {
    if (!members) {
        return <LoadingIndicator />;
    }

    return (
        <SelectionList>
            {members.map((m) => {
                const isSelected = !!value && m.profileId === value.profileId;
                return (
                    <SelectionList.Item
                        key={m.profileId}
                        selected={isSelected}
                        onChange={(checked) => onChange(checked ? m : null)}
                        label={
                            <div className={theme.itemContent}>
                                <ProfileIcon profileId={m.profileId} sizeInPx={36} />
                                <span className={theme.name}>{m.profileName}</span>
                            </div>
                        }
                    />
                );
            })}
        </SelectionList>
    );
};

export default OrderResponsibleSelection;
